import { useQuery } from '@tanstack/react-query'
import { useDebounce } from './useDebounce'
import { listStores } from '@/api/stores'
import { queryKeys } from '@/lib/queryKeys'
import type { PaginatedStoresResponse } from '@/types'

interface UseStoresListParams {
  search: string
  region: string
  isActive: 'all' | 'true' | 'false'
  page: number
  pageSize: number
}

export function useStoresList({
  search,
  region,
  isActive,
  page,
  pageSize,
}: UseStoresListParams) {
  const debouncedSearch = useDebounce(search, 300)
  const debouncedRegion = useDebounce(region, 300)

  const filters = {
    search: debouncedSearch,
    region: debouncedRegion,
    isActive,
    page,
    pageSize,
  }

  return useQuery<PaginatedStoresResponse>({
    queryKey: queryKeys.stores.list(filters),
    queryFn: () =>
      listStores({
        search: debouncedSearch || undefined,
        region: debouncedRegion || undefined,
        is_active:
          isActive === 'all' ? undefined : isActive === 'true' ? true : false,
        skip: (page - 1) * pageSize,
        limit: pageSize,
      }),
  })
}
